module.exports = __webpack_public_path__ + "static/media/Nutricheck_color.3ea017f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/central_fert/Nutricheck_color.png
// module id = 2490
// module chunks = 3